module.exports = __webpack_public_path__ + "static/media/system.cb002d08.png";